module.exports = __webpack_public_path__ + "media/images/views/lp/about-us/team-c0b3ff25236b03205f8915d1079e055f.jpg";